import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Role, useAuth } from './AuthContext';

const DEFAULT_ADMIN_ROLES: Role[] = ['admin', 'drh'];

interface ProtectedRouteProps {
  children: React.ReactElement;
  requireAdmin?: boolean;
  allowedRoles?: Role[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireAdmin = true,
  allowedRoles = DEFAULT_ADMIN_ROLES,
}) => {
  const { user, role, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        Chargement...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Si on demande un accès admin mais que le rôle n'est pas encore déterminé,
  // on évite les boucles de redirection en affichant un écran de chargement.
  if (requireAdmin && !allowedRoles.includes(role)) {
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <h1>Accès refusé : Accès admin requis.</h1>
        <p>Veuillez vous connecter avec un compte admin.</p>
        <button onClick={() => navigate('/login')}>Se connecter</button>
      </div>
    );
  }

  return children;
};

